export default __webpack_public_path__ + "static/media/pytestImage.98770d07.jpg";